import { defineMessages } from "react-intl";

export const messages = defineMessages({
  complements: {
    id: "ari.management.applyTo.supplements",
    defaultMessage: "Complements",
  },
  filterPlaceholder: {
    id: "ari.management.complements.filterPlaceholder",
    defaultMessage: "Filter by ticker...",
  },
});
